const getServiceBookingDetails = () => {
    return Promise.resolve({
        data: {
            serviceInfo: {
                activityId: '11500002',
                displayName: 'Feature Focus',
                description: 'Discover and try the latest products and trends from your favorite brands at this exclusive, open house event.',
                imageUrl: 'https://qa3.sephora.com/contentimages/happening/OLR-CD__perkface_30min.jpg',
                price: '$30',
                duration: '30 min',
                type: 'service'
            },
            storeInfo: {
                displayName: '<store name>',
                address: {
                    address1: '43550 Christy Street',
                    address2: 'Suite #R1A',
                    city: 'Fremont',
                    country: 'US',
                    phone: '(510) 656-1588',
                    postalCode: '94538',
                    state: 'CA'
                },
                curbsideHours: {
                    fridayHours: '11:00AM-08:00PM',
                    mondayHours: '11:00AM-08:00PM',
                    saturdayHours: '11:00AM-08:00PM',
                    sundayHours: '11:00AM-07:00PM',
                    thursdayHours: '11:00AM-08:00PM',
                    tuesdayHours: '11:00AM-08:00PM',
                    wednesdayHours: '11:00AM-08:00PM',
                    specialHours: [
                        {
                            endDate: '2024-02-21',
                            reason: 'Store Closed',
                            startDate: '2024-02-20',
                            storeHours: '',
                            textColor: '#CF112C'
                        }
                    ]
                },
                storeHours: {
                    fridayHours: '11:00AM-08:00PM',
                    mondayHours: '11:00AM-08:00PM',
                    saturdayHours: '11:00AM-08:00PM',
                    sundayHours: '11:00AM-07:00PM',
                    thursdayHours: '11:00AM-08:00PM',
                    tuesdayHours: '11:00AM-08:00PM',
                    wednesdayHours: '11:00AM-08:00PM',
                    specialHours: [
                        {
                            endDate: '2024-02-21',
                            reason: 'Store Closed',
                            startDate: '2024-02-20',
                            storeHours: '',
                            textColor: '#CF112C'
                        }
                    ]
                },
                storeId: '0048',
                storeType: 'SEPHORA',
                latitude: 37.505,
                longitude: -121.969,
                distance: 0,
                timeZone: 'America/Los_Angeles'
            }
        }
    });
};

export default getServiceBookingDetails;
